export default "__VITE_ASSET__B95P1RW9__"